const baseHeight = {
  xs: 'auto',
  md: '40px',
};

export const addButtonStyle = {
  backgroundColor: '#3F6CFF',
  fontSize: {
    xs: '14px',
    md: '16px',
  },
  height: baseHeight,
  '&:hover': {
    backgroundColor: '#3256CC',
    boxShadow: 'none',
  },
};

// export const disableButtonStyle = {
//   backgroundColor: '#8CA7FF',
//   fontSize: {
//     xs: '14px',
//     md: '16px',
//   },
//   height: baseHeight,
//   '&:hover': {
//     backgroundColor: '#8CA7FF',
//     boxShadow: 'none',
//   },
// };

export const disableButtonStyle = {
  backgroundColor: '#8CA7FF',
  color: '#9E9E9E',
  cursor: 'not-allowed',
  pointerEvents: 'none',
    fontSize: {
    xs: '14px',
    md: '16px',
  },
};



export const clearButtonStyle = {
  backgroundColor: '#F7C4BE',
  color: '#E74C3C',
  fontSize: {
    xs: '14px',
    md: '16px',
  },
  height: baseHeight,
  '&:hover': {
    backgroundColor: '#E74C3C',
    color: 'white',
    boxShadow: 'none',
  },
};

export const activeButtonStyle = {
  backgroundColor: '#B0CB1F',
  color: 'white',
  height: {
    xs: 'auto',
    md: '38px',
  },
  '&:hover': {
    boxShadow: 'none',
  },
};

export const inactiveButtonStyle = {
  backgroundColor: '#E74C3C',
  color: 'white',
  height: {
    xs: 'auto',
    md: '38px',
  },
  '&:hover': {
    boxShadow: 'none',
  },
};

export const cancelButtonStyle = {
  backgroundColor: '#E74C3C',
  color: '#fff',
  fontSize: {
    xs: '14px',
    md: '16px',
  },
  height: baseHeight,
  '&:hover': {
    backgroundColor: '#C22918',
    boxShadow: 'none',
  },
};

export const downloadButtonStyle = {
  backgroundColor: '#3F6CFF',
  fontSize: '14px',
  height: {
    xs: 'auto',
    md: '38px',
  },
  '&:hover': {
    backgroundColor: '#3256CC',
    boxShadow: 'none',
  },
};
export const previewButtonStyle = {
   backgroundColor:"#D9E2FF",
  fontSize: '14px',
  color:"#3256CC",
  height: {
    xs: 'auto',
    md: '38px',
  },
  '&:hover': {
    backgroundColor: '#3F6CFF',
    color:"#FFFFFF",
    boxShadow: 'none',
  },
};

export const savePinButtonStyle = {
  
  backgroundColor: '#FFD400',
  color: '#000',
  fontSize: 18,
  height: 45,
  mt:3,
  '&:hover': {
    backgroundColor: '#FFD33D',
  },
};

export const modifyButtonStyle = {
  backgroundColor: '#343B47',
  color: '#FFFFFF',
  fontSize: 16,
  height: 40,
  '&:hover': {
    backgroundColor: '#262B35',
  },
};


export const deleteButtonStyle = {
  backgroundColor: '#E74C3C',
  color: '#FFFFFF',
  fontSize: 16,
  height: 40,
  '&:hover': {
    backgroundColor: '#C22918',
  },
};

export const saveButtonStyle = {
  backgroundColor: '#3498DB',
  color: '#FFFFFF',
  fontSize: 16,
  height: 40,
  '&:hover': {
    backgroundColor: '#1E74AC',
    boxShadow:"none"
  },
};


export const canclButtonStyle = {
  backgroundColor: '#F7C4BE',
  color: '#E74C3C',
  fontSize: 16,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: '#E74C3C',
    color: '#FFFFFF',
    boxShadow: 'none',
    '& img': {
      filter: 'brightness(0) invert(1)', // makes icon white
    },
  },
};


export const resetButtonStyle = {
  padding: '8px 16px',
  height: '38px',
  alignSelf: 'flex-start',
  textTransform: 'none',
  borderRadius: 2,
  backgroundColor: '#D9E2FF',
  color: '#3F6CFF',
  borderColor: 'transparent',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: '#1e5eff',
    color: '#fff',
    '& img': {
      filter: 'brightness(0) invert(1)',
    },
  },
};
